/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CardReissueVirtual
 */
export interface CardReissueVirtual {
    /**
     * 
     * @type {string}
     * @memberof CardReissueVirtual
     */
    'cardType': CardReissueVirtualCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof CardReissueVirtual
     */
    'expiredDate': string;
}

export const CardReissueVirtualCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type CardReissueVirtualCardTypeEnum = typeof CardReissueVirtualCardTypeEnum[keyof typeof CardReissueVirtualCardTypeEnum];


